// extracted by mini-css-extract-plugin
export default {"imageUrl":"Support-Image_imageUrl__YSCaG"};